define((require) => {
    "use strict";

    const AnimationController = require("shared/ui/experience/widgets/animations/AnimationController");

    /**
     * The animation controller for a move animation.
     *
     * @class MoveAnimationController
     * @constructor
     */
    return AnimationController.extend({

        descriptor() {
            const appearanceDescriptor = this.getAppearanceDescriptor();
            const fromPoint = appearanceDescriptor.position;
            const horizontalMove = this.animationModel.get("horizontalMove") * appearanceDescriptor.scale.x;
            const verticalMove = this.animationModel.get("verticalMove") * appearanceDescriptor.scale.y;

            return {
                to: {
                    x: fromPoint.x + ((horizontalMove * this.unscaledExperienceSize.width) / 100),
                    y: fromPoint.y + ((verticalMove * this.unscaledExperienceSize.height) / 100)
                }
            };
        }

    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/animations/move/MoveAnimationController.js